<header class="header bg-emerland">
  <div
    class="header container-4k d-flex align-items-center justify-content-between"
  >
    <div class="position-relative d-flex align-items-center">
      <div class="sispac-logo-container">
        <img 
          *ngIf="isChristmasMode"
          src="../../../assets/img/christmas/Gemini_Generated_Image_rcto20rcto20rcto-removebg-preview.png" 
          alt="Logo Natal" 
          class="logo-icon">
        <img 
          *ngIf="!isChristmasMode"
          src="../../../assets/img/sispac-new/logo-sispac-new.png" 
          alt="SISPAC Logo" 
          class="logo-icon">
        <img 
          *ngIf="!isChristmasMode"
          src="../../../assets/img/sispac-new/nome-sispac-new.png" 
          alt="SISPAC" 
          class="logo-text">
      </div>
      <nav class="nav-bar">
        <ul class="nav">
          <li class="nav-item" *ngFor="let item of navItems; let i = index">
            <app-nav-item [item]="item"></app-nav-item>
          </li>
        </ul>
      </nav>
    </div>

    <div class="profile-section" (click)="toggleProfileOverlay($event)">
      <div class="user-info">
        <span class="user-name">{{ nomeUsuario }}</span>
        <span class="user-orgao">{{ lotacaoUsuario }}</span>
      </div>
      <div class="profile-icon">
        <mat-icon>account_box</mat-icon>
      </div>
    </div>

  </div>
</header>
